'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilService = UtilService;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UtilService($window) {
  'ngInject';

  var Util = {
    safeCb: function safeCb(cb) {
      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
    },
    urlParse: function urlParse(url) {
      var a = document.createElement('a');
      a.href = url;

      if (a.host === '') {
        a.href = a.href;
      }

      return a;
    },
    isSameOrigin: function isSameOrigin(url, origins) {
      url = Util.urlParse(url);
      origins = origins && [].concat(origins) || [];
      origins = origins.map(Util.urlParse);
      origins.push($window.location);
      origins = origins.filter(function (o) {
        var hostnameCheck = url.hostname === o.hostname;
        var protocolCheck = url.protocol === o.protocol;

        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
        return hostnameCheck && protocolCheck && portCheck;
      });
      return origins.length >= 1;
    }
  };

  return Util;
}


// WEBPACK FOOTER //
// ./client/components/util/util.service.js